import { API } from '@Providers';

export default async function() {
  const endpoint = '/api/sanctum/csrf-cookie';
  
  return API({endpoint});
}